import { render, staticRenderFns } from "./TonosGlobalTab.vue?vue&type=template&id=1470e096&scoped=true&"
import script from "./TonosGlobalTab.vue?vue&type=script&lang=js&"
export * from "./TonosGlobalTab.vue?vue&type=script&lang=js&"
import style0 from "./TonosGlobalTab.vue?vue&type=style&index=0&id=1470e096&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1470e096",
  null
  
)

export default component.exports